module.exports = __webpack_public_path__ + "static/media/528GriffinStNW_2018-06-05_13.887a1e3b.jpg";